import Div from "@jumbo/shared/Div";
import React from "react";
import {Alert, Button, FormControl, TextField,InputAdornment, Tooltip, IconButton} from "@mui/material";
import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import {useTranslation} from "react-i18next";

import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";


const steps = ['Basic Info', 'Complete', 'Finish'];

const Step1 = ({hide, teacherFeedback, handleNext, setShowTeacherFeedBack}) => {

    const [values, setValues] = React.useState({});
    const [errMsg, setErrMsg] = React.useState('');
    const {t} = useTranslation();

    React.useEffect(() => {

        setValues({...teacherFeedback});

    }, [teacherFeedback]);


    const handleChange = (prop) => (event) => {
        setValues({...values, [prop]: event.target.value});
    };

    const copyToClipboard = async (text) => {
        if (!text) return;
        try {
            await navigator.clipboard.writeText(String(text));
            // optional: setErrMsg("");
        } catch (e) {
            setErrMsg("Copy failed. Please copy manually.");
        }
    };

    const normalizeUrl = (url) => {
        if (!url) return "";
        const trimmed = String(url).trim();
        if (!trimmed) return "";
        if (/^https?:\/\//i.test(trimmed)) return trimmed;
        return `https://${trimmed}`;
    };

    const openLink = (url) => {
        const finalUrl = normalizeUrl(url);
        if (!finalUrl) return;
        window.open(finalUrl, "_blank", "noopener,noreferrer");
    };

    const LinkActionsAdornment = ({ value }) => (
        <InputAdornment position="end">
            <Tooltip title="Open link">
        <span>
          <IconButton
              edge="end"
              size="small"
              onClick={() => openLink(value)}
              disabled={!value || !String(value).trim()}
          >
            <OpenInNewRoundedIcon fontSize="small" />
          </IconButton>
        </span>
            </Tooltip>

            <Tooltip title="Copy">
        <span>
          <IconButton
              edge="end"
              size="small"
              onClick={() => copyToClipboard(value)}
              disabled={!value || !String(value).trim()}
          >
            <ContentCopyRoundedIcon fontSize="small" />
          </IconButton>
        </span>
            </Tooltip>
        </InputAdornment>
    );

    const CopyAdornment = ({ value }) => (
        <InputAdornment position="end">
            <Tooltip title="Copy">
        <span>
          <IconButton
              edge="end"
              size="small"
              onClick={() => copyToClipboard(value)}
              disabled={!value || !String(value).trim()}
          >
            <ContentCopyRoundedIcon fontSize="small" />
          </IconButton>
        </span>
            </Tooltip>
        </InputAdornment>
    );


    return <Div sx={{width: '100%', minHeight: 100, minWidth: {xs: 500, sm: 300, xl: 500}}}>

        <Div sx={{mt: 3}}>

            <FormControl noValidate autoComplete="off" fullWidth>
                <Div
                    sx={{
                        '& .MuiTextField-root': {
                            mb: 1.4,
                            mt: 0.5
                        },
                    }}
                >


                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}
                            label={t('feedbackForm.feedback')}
                            multiline
                            rows={8}
                            fullWidth
                            value={values.comments}
                            onChange={handleChange('comments')}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}
                            label={t('feedbackForm.bookName')}
                            placeholder="Book Name"
                            fullWidth
                            value={values.bookName}
                            onChange={handleChange('bookName')}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}
                            label={t('feedbackForm.pageNo')}
                            placeholder="Page Number"
                            fullWidth
                            value={values.pageNumber}
                            onChange={handleChange('pageNumber')}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}

                            label={t('feedbackForm.worked')}
                            placeholder="Worked On Text Here"
                            fullWidth
                            value={values.workedOn}
                            onChange={handleChange('workedOn')}
                        />
                    </FormControl>
                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}

                            label={t('feedbackForm.completed')}
                            placeholder="Completed Text Here"
                            fullWidth
                            value={values.completed}
                            onChange={handleChange('completed')}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}

                            label={t('feedbackForm.home')}
                            placeholder="Enter Link here"
                            fullWidth
                            value={values.homeWorkLink}
                            onChange={handleChange('homeWorkLink')}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{
                                readOnly: true,
                                endAdornment: <LinkActionsAdornment value={values.homeWorkLink2} />,
                            }}
                            label={t("feedbackForm.home2")}
                            placeholder="Enter Link here"
                            fullWidth
                            value={values.homeWorkLink2 || ""}
                            onChange={handleChange("homeWorkLink2")}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{
                                readOnly: true,
                                endAdornment: <CopyAdornment value={values.homeWorkLinkPassword} />,
                            }}
                            label={t("feedbackForm.homePass")}
                            placeholder="Enter Link Password here"
                            fullWidth
                            value={values.homeWorkLinkPassword || ""}
                            onChange={handleChange("homeWorkLinkPassword")}
                        />
                    </FormControl>

                    {/*<FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}

                            label={t('feedbackForm.home2')}
                            placeholder="Enter Link here"
                            fullWidth
                            value={values.homeWorkLink2}
                            onChange={handleChange('homeWorkLink2')}
                        />
                    </FormControl>

                    <FormControl fullWidth>
                        <TextField
                            InputProps={{readOnly: true}}

                            label={t('feedbackForm.homePass')}
                            placeholder="Enter Link Password here"
                            fullWidth
                            value={values.homeWorkLinkPassword}
                            onChange={handleChange('homeWorkLinkPassword')}
                        />
                    </FormControl>*/}

                    <Stack
                        sx={{
                            mb: 2,
                            width: '90%',
                            mx: 'auto',
                            display: 'block',
                            position: 'relative', // Add position relative to enable absolute positioning of loader
                        }}
                        spacing={2}>
                        {errMsg && <Alert severity="error">{errMsg}</Alert>}
                    </Stack>

                    <Div sx={{display: 'flex', flexDirection: 'row', pt: 2}}>

                        <Button
                            onClick={() => {
                                hide()
                            }}
                            sx={{mr: 1}}
                        >
                            {t("common.closeBtn")}
                        </Button>
                        <Button
                            onClick={() => {
                                setShowTeacherFeedBack({show: false});
                            }}
                            sx={{mr: 1}}
                        >
                            {t("common.backBtn")}
                        </Button>
                        <Div sx={{flex: '1 1 auto'}}/>


                        <LoadingButton variant={"variant"} onClick={() => {
                            handleNext(3)
                        }}>
                            {t("common.nextBtn")}
                        </LoadingButton>

                    </Div>

                </Div>
            </FormControl>
        </Div>
    </Div>;

}

export default Step1;
